import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import { StyledTypographyWithDisabled } from 'components/StyledTypographyWithDisabled';
import {
  getMenuItemNamesLightColor,
  getMenuItemNamesMediumColor
} from 'styles/helpers/getThemeStyles';

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  '& .MuiSvgIcon-root': {
    fill: getMenuItemNamesLightColor(theme)
  },
  '&.Mui-checked': {
    '& .MuiSvgIcon-root': {
      fill: getMenuItemNamesMediumColor(theme)
    }
  },
  '&.MuiCheckbox-root': {
    alignItems: 'flex-start'
  }
}));

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  '&.MuiFormControlLabel-root': {
    alignItems: 'flex-start'
  },
  '& .MuiFormControlLabel-label': {
    padding: '11px 0 5px'
  }
}));

function CheckBoxItem({
  checked,
  value,
  label,
  disabled,
  name,
  onChange,
  required
}) {
  const getCheckboxInputProps = () => {
    const inputProps = {};
    if (required) {
      inputProps['aria-required'] = true;
    }
    return inputProps;
  };

  const styles = { variant: ITEM_DESCRIPTION_AND_PRICES };

  return (
    <StyledFormControlLabel
      control={
        <StyledCheckbox
          name={name}
          value={value}
          label={label}
          disabled={disabled}
          checked={checked}
          onChange={onChange}
          inputProps={getCheckboxInputProps()}
        />
      }
      label={
        <StyledTypographyWithDisabled isDisabled={disabled} {...styles}>
          {label}
        </StyledTypographyWithDisabled>
      }
    />
  );
}

CheckBoxItem.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  value: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  required: PropTypes.bool
};

export default CheckBoxItem;
